<template>
  <div>
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>
          <div class="d-flex justify-content-between">
            <h2 class="mb-2">{{ $t("clinic.Doctor-Information") }}</h2>
          </div>
          <div>
            <h5 class="my-2">
              <b>{{ $t("clinic.doctors-name") }} :</b>
              <p class="mx-2 d-inline d-inline">
                {{ doctorData.name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("clinic.doctors-phone") }} :</b>
              <p class="mx-2 d-inline d-inline">
                {{ doctorData.phone }}
              </p>
            </h5>
          </div>

          <hr class="invoice-spacing" />
          <h2 class="my-2">{{ $t("clinic.Doctor-Updates") }}</h2>
          <div>
            <h5 class="my-2">
              <b>{{ $t("clinic.Date-of-Last-Update-Doctor") }}:</b>
              <p class="mx-2 d-inline">{{ doctorData.updated_at }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("clinic.Doctor-Added-At") }}:</b>
              <p class="mx-2 d-inline">{{ doctorData.created_at }}</p>
            </h5>
          </div>
          <hr class="invoice-spacing" />
        </b-card>
        <div>
          <b-card>
            <div>
              <!-- Data Table  -->
              <div class="d-flex justify-content-between mb-2">
                <h2>{{ $t("hospital.doctor-surgeries") }}</h2>
              </div>

              <b-row class="d-flex justify-content-end">
                <b-col lg="3">
                  <b-form-group
                    :label="$t('hospital.patient-name')"
                    label-for="Name"
                  >
                    <b-form-input
                      id="Name"
                      v-model="name"
                      :placeholder="$t('hospital.patient-name')"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg="3">
                  <AutoComplete
                    v-model="surgery_id"
                    :label="$t('surgery.surgery')"
                    :placeholder="$t('surgery.surgery')"
                    :serializer="(val) => val.id"
                    param-query="search"
                    :endpoint="`surgery`"
                    text-title="title"
                  />
                </b-col>
                <b-col lg="2">
                  <b-form-group
                    :label="$t('common.from')"
                    label-for="entry_date"
                  >
                    <datepicker
                      v-model="from"
                      :calendar-button="true"
                      :clear-button="true"
                      :bootstrap-styling="true"
                      class="datebtn2"
                      placeholder="YYYY-MM-DD"
                    ></datepicker>
                  </b-form-group>
                </b-col>
                <b-col lg="2">
                  <b-form-group :label="$t('common.to')" label-for="entry_date">
                    <datepicker
                      v-model="to"
                      :calendar-button="true"
                      :clear-button="true"
                      :bootstrap-styling="true"
                      class="datebtn2"
                      placeholder="YYYY-MM-DD"
                    ></datepicker>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex align-items-center mb-2 mb-lg-0" lg="2">
                  <b-button variant="primary" @click="getDoctorsSurgeries()">
                    {{ $t("common.search") }}
                    <b-icon-search class="ml-1"></b-icon-search>
                  </b-button>
                </b-col>
              </b-row>

              <b-table
                :items="this.data"
                responsive
                :fields="tableColumns"
                primary-key="id"
                show-empty
                empty-text="No matching results found"
                class="position-relative"
                v-if="!loading"
              >
                <!-- Column: Actions -->
              </b-table>
              <template v-if="loading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div class="mx-2 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  >
                    <span class="text-muted"
                      >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                    </span>
                  </b-col>
                  <!-- Pagination -->
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    @click="getDoctorsSurgeries()"
                  >
                    <b-pagination
                      v-model="page"
                      :total-rows="this.dataCount"
                      :per-page="take"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BTable,
  BPagination,
  BSpinner,
  BIconSearch,
} from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BCard,
    BButton,
    BTable,
    BPagination,
    BSpinner,
    BIconSearch,
    Datepicker,
    AutoComplete,
  },
  data() {
    return {
      loading: true,
      params: {
        form: {},
        path: "",
      },
      doctorData: {},
      take: 10,
      dataCount: 0,
      data: [],
      tableColumns: [
        {
          key: "patient_card.patient.name",
          label: this.$t("hospital.patient-name"),
          sortable: true,
        },
        {
          key: "patient_card.patient.phone",
          label: this.$t("hospital.patient-phone"),
          sortable: true,
        },

        {
          key: "patient_card.patient_case",
          label: this.$t("reception.patient-case"),
          sortable: true,
        },

        {
          key: "diagnosis",
          label: this.$t("reception.diagnosis"),
          sortable: true,
        },
        {
          key: "surgery.title",
          label: this.$t("surgery.surgery"),
          sortable: true,
        },
        {
          key: "surgery_date_time",
          sortable: true,
          label: this.$t("hospital.surgery-date"),
        },
      ],
      page: 1,
      surgery_id: "",
    };
  },
  mounted() {
    this.getDoctorsSurgeries();
  },

  methods: {
    async getDoctorsSurgeries() {
      this.loading = true;
      // check if there are any null value in the obj we sending
      let url = `/patient-surgery/doctor/${this.$route.params.id}?page=${this.page}&take=${this.take}&sort=-id&include=surgery`;
      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`;
      }
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`;
      }
      if (this.name) {
        url += `&filter[patientCard.patient.name]=${this.name}`;
      }
      if (this.surgery_id) {
        url += `&filter[surgery_id]=${this.surgery_id}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
  },
};
</script>
